import uniqueId from 'lodash/uniqueId'
import { type MaybeRef, type Ref, toRef, toValue } from 'vue'
import ModalDialog from '../components/js/Components/UI/Modal/ModalDialog.vue'
import ModalConfirmation from '../components/js/Components/UI/Modal/ModalConfirmation.vue'

type ModalDialogType = InstanceType<typeof ModalDialog>
type ModalConfirmationType = InstanceType<typeof ModalConfirmation>

export default function useModal({
  prefix = '',
  modal = null,
}: { prefix?: string; modal?: MaybeRef<ModalDialogType | ModalConfirmationType | null> } = {}) {
  const modalId: string = uniqueId(prefix)
  const modalRef: Ref<ModalDialogType | ModalConfirmationType | null> = toRef(modal)

  function open() {
    const modal = toValue(modalRef)
    modal?.open()
  }

  function close() {
    const modal = toValue(modalRef)
    modal?.close()
  }

  return {
    modal: modalRef,
    modalId,
    open,
    close,
  }
}
